import { analytics } from '../../utils/analytics';

export const forceImageReload = (imageId: string) => {
  if(!imageId) {
    return;
  }

  const htmlImgElement: any = document.getElementById(imageId);
  if(!htmlImgElement || !htmlImgElement?.src) {
    return;
  }

  // reload only once
  if(htmlImgElement.src.indexOf('reload=0') === -1) {
    htmlImgElement.src = `${htmlImgElement.src}.${new Date().getTime()}?reload=0`;
  }

  return htmlImgElement;
}

export const onImageLoadError = (imageId: string, imageSrc: string, error: Error) => {
    analytics.trackEvent('image_load_error', {
      imageId,
      imageSrc,
      errorMessage: error?.message
    });
  
    reloadWeChatImages(imageSrc, imageId);
  }

  export const reloadWeChatImages = (imageSrc: string, imageId: string) => {
    // When the wechat user sends a message to the CSS agent, some times 
    // it takes a little while for the wechat network to load image. When that happens, 
    // the agent sees a default image, with an error text stating privacy issues.
    // The workaround is to reload the image, by suffixing its url with the date so that 
    // its not fetch by the browser client. That little time seems to be all needed
    // for most cenarios.
    if((imageSrc?.indexOf('mmbiz.qpic.cn') !== -1) && (imageSrc?.indexOf('reload=0') === -1)) {
      setTimeout(()=> {
        return forceImageReload(imageId);
      }, 2000)
    }
  }
  
  export const onImageLoadSuccess = (imageId: string, imageSrc: string) => {
    analytics.trackEvent('image_load_success', {
      imageId,
      imageSrc
    });

    reloadWeChatImages(imageSrc, imageId);
  }
  